var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutomation = function SvgAutomation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M10 50a2 2 0 0 1 2-2h46a2 2 0 0 1 2 2v17a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2zm16 8a5 5 0 1 1-10 0 5 5 0 0 1 10 0m7-2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h21a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    fillRule: "evenodd",
    d: "M13.839 29.5H11a1.5 1.5 0 0 0 0 3h2.839a7 7 0 1 1 0-3",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M13.839 32.5a7 7 0 0 0 0-3H25a1.5 1.5 0 0 1 1.5 1.5v17h-3V32.5z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M65 41a5 5 0 1 0-4.772-6.5H64a1.5 1.5 0 0 1 0 3h-3.772A5 5 0 0 0 65 41",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M60.229 34.5H44a1.5 1.5 0 0 0-1.5 1.5v12h3V37.5h14.729A5 5 0 0 1 60 36c0-.523.08-1.026.229-1.5",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M36.5 18.876a9 9 0 1 0-3 0V14a1.5 1.5 0 0 1 3 0z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M36.5 18.876a9 9 0 0 1-3 0V48h3z",
    clipRule: "evenodd"
  })));
};
export default SvgAutomation;